module.exports = __webpack_public_path__ + "static/img/anxunu04.e79f292d.png";